import { ref as l, provide as g, computed as h, defineComponent as j, onMounted as D, onUnmounted as b, unref as O, inject as w } from "vue";
import { useId as x } from "./index327.js";
import { render as y } from "./index345.js";
let u = Symbol("DescriptionContext");
function S() {
  let t = w(u, null);
  if (t === null) throw new Error("Missing parent");
  return t;
}
function k({ slot: t = l({}), name: i = "Description", props: s = {} } = {}) {
  let e = l([]);
  function n(r) {
    return e.value.push(r), () => {
      let o = e.value.indexOf(r);
      o !== -1 && e.value.splice(o, 1);
    };
  }
  return g(u, { register: n, slot: t, name: i, props: s }), h(() => e.value.length > 0 ? e.value.join(" ") : void 0);
}
j({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(t, { attrs: i, slots: s }) {
  var e;
  let n = (e = t.id) != null ? e : `headlessui-description-${x()}`, r = S();
  return D(() => b(r.register(n))), () => {
    let { name: o = "Description", slot: p = l({}), props: a = {} } = r, { ...d } = t, c = { ...Object.entries(a).reduce((m, [f, v]) => Object.assign(m, { [f]: O(v) }), {}), id: n };
    return y({ ourProps: c, theirProps: d, slot: p.value, attrs: i, slots: s, name: o });
  };
} });
export {
  k as useDescriptions
};
